import styles from "./LandingPage.module.css";
interface Props {
  children: React.ReactNode;
}

export const LandingPage = ({ children }: Props) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.container_logo}>
          {/* We apply a random seed to disable caching, because this will prevent the animation */}
          {/* <img
            src={`${process.env.PUBLIC_URL}/assets/logos/Logs-Main-LandingPage.svg?seed=${new Date().getSeconds()}`}
            alt="LOGS"/> */}
          <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 300">
            <defs>
              <style
                dangerouslySetInnerHTML={{
                  __html: `
            .cls-1 {
              fill: #2b4865;
              stroke-width: 0px;
            }
            .cls-2 {
              fill: #a71e69;
            }
            @keyframes animate-svg-stroke {
              0% {
                opacity: 1;
                stroke-dashoffset: 1908px;
                stroke-dasharray: 1908px;
                stroke: #00000026;
              }
              100% {
                opacity: 1;
                stroke-dashoffset: 0;
                stroke-dasharray: 1908px;
                stroke: #A71E69;
              }
            }
            @keyframes animate-svg-fill {
              0% {
                fill: transparent;
              }
              100% {
                fill: rgb(167, 30, 105);
              }
            }
            #octahedron {
              animation: animate-svg-stroke 3s cubic-bezier(0.47, 0, 0.745, 0.715) 0.3s both,
                animate-svg-fill 3s cubic-bezier(0.645, 0.045, 0.355, 1) 0.6s both;
            }
            `,
                }}
              />
            </defs>
            <path
              className="cls-1"
              d="M750.86,203.06c-30.34,0-52.26-26.01-52.26-55.63s22.4-54.91,51.29-54.91c14.45,0,27.87,6.01,38.45,17.88l22.96-22.45c-14.45-16.13-36.36-26.49-61.41-26.49-47.68,0-84.77,38.77-84.77,85.97,0,40.49,27.04,74.87,66.6,83.58l28.83-28.83c-3.18.57-6.43.88-9.7.88Z"
            />
            <g>
              <path className="cls-1" d="M405.41,199.58h62.85v29.62h-96.33V63.28h33.47v136.3Z" />
              <path
                className="cls-1"
                d="M475.73,146.36c0-47.2,37.09-85.97,84.28-85.97s84.53,38.77,84.53,85.97-37.57,85.73-84.53,85.73-84.28-38.77-84.28-85.73ZM610.82,146.36c0-29.86-21.19-54.42-50.81-54.42s-50.81,24.56-50.81,54.42,20.95,54.18,50.81,54.18,50.81-24.32,50.81-54.18Z"
              />
              <path
                className="cls-1"
                d="M848.02,181.04h33.47c.24,11.8,11.8,21.67,27.21,21.67s24.8-8.19,24.8-19.99c0-9.15-6.74-15.65-20.95-19.99l-20.23-5.78c-36.36-9.63-42.87-31.55-42.87-46.48,0-29.62,25.53-50.09,57.31-50.09s55.39,19.02,55.39,50.57h-33.47c0-11.8-8.19-20.95-22.64-20.95-13,0-22.88,8.67-22.88,19.75,0,4.09,1.2,12.52,18.54,17.58l18.54,5.3c25.04,7.47,46.96,20.23,46.96,48.4,0,32.99-28.18,51.05-59.48,51.05-35.4,0-59.72-21.91-59.72-51.05Z"
              />
            </g>
            <path
              className="cls-2"
              id="octahedron"
              d="M314.49,135.9s0-.05,0-.07c0-.06-.01-.12-.02-.17-.01-.15-.04-.29-.08-.43-.02-.06-.04-.13-.07-.19-.06-.14-.14-.28-.24-.4-.02-.03-.03-.07-.06-.1,0-.01-.02-.02-.03-.03-.13-.15-.28-.28-.45-.39l-114.77-71.02c-.12-.08-.26-.13-.39-.17-.04-.01-.07-.04-.1-.05,0,0,0,0,0,0-.19-.05-.38-.08-.58-.08-.07,0-.13.02-.19.03-.13.01-.25.03-.38.07-.07.02-.14.06-.21.09-.08.03-.16.06-.24.1-.03.02-.05.04-.07.06-.07.04-.12.1-.18.15-.09.08-.18.16-.25.25-.02.03-.05.04-.07.07l-70.87,95.52c-.05.07-.09.15-.13.22-.01.03-.04.04-.05.07,0,.01,0,.03-.01.04-.09.2-.15.41-.18.62,0,.05,0,.09,0,.14-.01.21,0,.41.05.62,0,.01,0,.02,0,.03,0,0,0,0,0,.01.06.21.16.4.28.57.03.04.05.08.08.11.14.17.29.33.48.45,0,0,.01.02.02.02l112.39,70.89s.09.04.14.07c.05.03.11.06.16.08.08.03.17.06.25.08.05.01.1.03.15.04.1.02.2.03.3.03.04,0,.07.01.11.01,0,0,.01,0,.02,0,.13,0,.27-.02.4-.05,0,0,0,0,0,0h0s0,0,0,0c.21-.05.41-.14.6-.25.06-.04.11-.1.17-.14.1-.08.2-.14.29-.24.02-.02.02-.04.03-.06.01-.02.03-.03.05-.04l73.25-95.39s.02-.04.03-.06c.11-.16.2-.32.27-.51,0-.02.02-.03.02-.05.05-.17.09-.35.09-.54ZM130.03,159.41l69.56-36.46,4.41,65.6-9.22-3.63-64.75-25.51ZM230.45,105.26l-27.04,14.17-3.42-50.83,30.46,36.66ZM230.89,106.55l4.16,67.64-27.01,14.18-.2-2.94-4.34-64.53,27.39-14.35ZM232.23,106.47l73.44,27.53,2.72,1.68-72.04,37.82-4.12-67.04ZM231.9,104.91l-28.33-34.09,96.21,59.54-67.88-25.44ZM197.68,94.65l1.8,26.83-67.62,35.44,64.18-86.51,1.63,24.24ZM238.29,226.93l-28.9-34.7,25.93-13.61,2.97,48.32ZM146.09,170.08l58.92,23.21,24.48,29.4-83.4-52.61ZM239.66,227.33l-3.04-49.4,8.97-4.71,59.67-31.33-65.61,85.44Z"
            />
            <polygon
              className="cls-2"
              points="761.32 137.57 730.03 168.86 795.87 168.86 795.87 234.71 827.17 203.42 827.17 137.57 761.32 137.57"
            />
          </svg>
        </div>
        <div className={styles.container_child}>{children}</div>
      </div>
      <div className={styles.footer}>
        <small>
          © 2015 - 2025 Bruker BioSpin GmbH &amp; Co. KG | <a href="https://logs.sciy.com/legal">Legal Notice</a> |{" "}
          <a href="https://logs.sciy.com/privacy">Privacy Policy</a>
        </small>
      </div>
    </div>
  );
};
